/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import Home_Activos from "./Componentes/Home_Activos";
import Home_Plan from "./Componentes/Home_Plan";
import Home_Proposito from "./Componentes/Home_Proposito";
import Home_Unica from "./Componentes/Home_Unica";
import Home_Preguntas from "./Componentes/Home_Preguntas";

const Seccion_Home = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -14.5, zIndex: 1}}>
                <Home_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -16, zIndex: 2}}>
                <Home_Activos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -14, zIndex: 1}}>
                <Home_Plan/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 2, mt: -14.5}}>
                <Home_Proposito/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -14, zIndex: 2}}>
                <Home_Unica/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1, mt: -14}}>
                <Home_Preguntas/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Home